import React from "react";

import './style.scss';

import {Checkbox} from './components/checkbox';

export const CheckboxQuestion = ({
    theme,
    options,
    componentName,
    answersOnQuestions,
    setAnswersOnQuestions,
}) =>
{
    const classes = ['choice'];

    if (theme !== undefined) {
        classes.push.apply(classes,
            theme.split(' ').map(modifier => `choice-theme-${modifier}`)
        );
    }

    return (
        <div className={classes.join(' ')}>
            {
                options && Array.isArray(options)
                    ? options.map((optionsItem) => (
                            Checkbox({
                                ...optionsItem,
                                componentName,
                                answersOnQuestions,
                                setAnswersOnQuestions
                            })
                        )
                    )
                    : null
            }
        </div>
    )
}
